import Icon from '../../marker/rectangle/Rectangle';
import damStatusColor from './DamStatusColor';
import ruleCurve from './DamRuleCurve.json';

const DamLargeColorCurve = (
  volume,
  storagePercent,
  damID,
  currentDate,
  damType = 'rid',
) => {
  let rule;
  if (damType === 'rid') {
    rule = ruleCurve.find(
      (item) => item.dam_id === damID && item.date === currentDate,
    );
  } else {
    rule = ruleCurve.find(
      (item) => item.egat_dam_id === damID && item.date === currentDate,
    );
  }
  // console.log(damID);
  // console.log("egat:", storagePercent);
  let color;
  let icon;
  let colorCode;
  const damIcon = Icon;
  // const {
  //   grey, yellow, green, blue, red, brown,
  // } = damStatusColor;
  const grey = damStatusColor[0];
  const yellow = damStatusColor[6];
  const orange = damStatusColor[7];
  const green = damStatusColor[2];
  // const blue = damStatusColor[3];
  // const red = damStatusColor[4];
  const brown = damStatusColor[5];

  if (rule === undefined) {
    color = grey;
    icon = damIcon.grey;
    return { color, icon, colorCode };
  }

  const upperRule = rule.revised_urc;
  const lowerRule = rule.revised_lrc;

  if (storagePercent > 100) {
    color = brown;
    icon = damIcon.red;
  } else if (volume > upperRule) {
    color = orange;
    icon = damIcon.orange;
  } else if (volume < lowerRule) {
    color = yellow;
    icon = damIcon.yellow;
  } else if (volume > lowerRule && volume <= upperRule) {
    color = green;
    icon = damIcon.green;
  } else {
    color = grey;
    icon = damIcon.grey;
  }

  return { color, icon, colorCode };
};

export default DamLargeColorCurve;
